import {
  faArrowLeft,
  faCheckCircle,
  faLock,
  faPlus,
  faTachometer,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import Scroll from "react-scroll";
import { useRecoilState } from "recoil";

import { postOrgUserCreateAPI } from "../../API/Org-User";
import { topAlertMessageState, topAlertStatusState } from "../../AppState";
import FormErrorBox from "../../Components/Reusable/FormErrorBox";
import FormInputField from "../../Components/Reusable/FormInputField";
import PageLoadingContent from "../../Components/Reusable/PageLoadingContent";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { postPromoCodeCreateAPI } from "../../API/PromoCode";

function OrgUserAdd() {
  ////
  //// Global state.
  ////

  const [topAlertMessage, setTopAlertMessage] =
    useRecoilState(topAlertMessageState);
  const [topAlertStatus, setTopAlertStatus] =
    useRecoilState(topAlertStatusState);

  ////
  //// Component states.
  ////

  const [errors, setErrors] = useState({});
  const [user, setUser] = useState({});
  const [forceURL, setForceURL] = useState("");
  const [isFetching, setFetching] = useState(false);
  const [birthday, setBirthday] = useState(null);
  const [clinicCode, setClinicCode] = useState(null);
  const [stripeCheckoutIntent, setStripeCheckoutIntent] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [injuryDate, setInjuryDate] = useState(null);
  const [trialStatus, setTrialStatus] = useState("");
  const [password, setPassword] = useState("");
  const [passwordRepeated, setPasswordRepeated] = useState("");
  const [profile] = useLocalStorage("RHEA_CMS_USER_PROFILE");
  ////
  //// API.
  ////

  function onUserAddSuccess(response) {
    console.log("onUserAddSuccess: Starting..."); // For debugging purposes only.

    // Add notification.
    setTopAlertStatus("success");
    setTopAlertMessage("User created");
    setTimeout(() => {
      console.log(
        "onUserAddSuccess: topAlertMessage, topAlertStatus:",
        topAlertMessage,
        topAlertStatus
      );
      setTopAlertMessage("");
    }, 2000);

    setForceURL("/org-users");
  }

  function onUserAddError(apiErr) {
    console.log("onUserAddError: Starting..."); // For debugging purposes only.
    setErrors(apiErr);

    // Add notification.
    setTopAlertStatus("danger");
    setTopAlertMessage("Failed Adding User");
    setTimeout(() => {
      console.log(
        "onUserAddError: topAlertMessage, topAlertStatus:",
        topAlertMessage,
        topAlertStatus
      );
      setTopAlertMessage("");
    }, 2000);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onUserAddDone() {
    console.log("onUserAddDone: Starting...");
    setFetching(false);
  }

  ////
  //// Event handling.
  ////

  const onSubmitClick = (e) => {
    console.log("onSubmitClick: Beginning...");
    setErrors({});
    setFetching(true);

    // To Snake-case for API from camel-case in React.
    const postData = {
      email: email.toLowerCase(),
      firstName: firstName,

      lastName: lastName,

      password: password,

      organizationId: profile.organizationId,
    };

    postOrgUserCreateAPI(
      postData,
      onUserAddSuccess,
      onUserAddError,
      onUserAddDone
    );
  };

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      window.scrollTo(0, 0);
    }

    return () => {
      mounted = false;
    };
  }, []);

  if (forceURL !== "") {
    return <Navigate to={forceURL} />;
  }

  return (
    <>
      <div class="container">
        <section class="section">
          {/* Desktop Breadcrumbs */}
          <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to="/org-dashboard">
                  <FontAwesomeIcon className="fas" icon={faTachometer} />
                  &nbsp;Dashboard
                </Link>
              </li>
              <li class="">
                <Link to="/org-users" aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faUsers} />
                  &nbsp;Users
                </Link>
              </li>
              <li class="is-active">
                <Link aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faPlus} />
                  &nbsp;Add User
                </Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Breadcrumbs */}
          <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
            <ul>
              <li class="">
                <Link to={`/org-users`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                  &nbsp;Back to Users
                </Link>
              </li>
            </ul>
          </nav>

          {/* Page */}
          <nav class="box">
            <p class="title is-4">
              <FontAwesomeIcon className="fas" icon={faPlus} />
              &nbsp;Add User
            </p>
            {isFetching ? (
              <PageLoadingContent displayMessage={"Please wait"} />
            ) : (
              <>
                <FormErrorBox errors={errors} />
                <div class="columns">
                  <div class="column">
                    <FormInputField
                      label="Email"
                      name="email"
                      placeholder="Text input"
                      value={email}
                      errorText={errors && errors.email}
                      helpText=""
                      onChange={(e) => setEmail(e.target.value)}
                      maxWidth="300px"
                    />

                    <FormInputField
                      label="First Name"
                      name="firstName"
                      placeholder="Text input"
                      value={firstName}
                      errorText={errors && errors.firstName}
                      helpText=""
                      onChange={(e) => setFirstName(e.target.value)}
                      maxWidth="200px"
                    />

                    <FormInputField
                      label="Last Name"
                      name="lastName"
                      placeholder="Text input"
                      value={lastName}
                      errorText={errors && errors.lastName}
                      helpText=""
                      onChange={(e) => setLastName(e.target.value)}
                      maxWidth="200px"
                    />

                    <div class="has-background-white-bis p-3 mb-4 is-round">
                      <p class="title is-6">
                        <FontAwesomeIcon className="fas" icon={faLock} />
                        &nbsp;Account Credentials
                      </p>
                      <p class="mb-4 has-text-grey">
                        To assign a password to the user account then please set
                        the following fields. Leave blank if you want user to
                        run forget password on account.
                      </p>
                      <FormInputField
                        label="Password (Optional)"
                        name="password"
                        type="password"
                        placeholder="Text input"
                        value={password}
                        errorText={errors && errors.password}
                        helpText=""
                        onChange={(e) => setPassword(e.target.value)}
                        isRequired={true}
                        maxWidth="380px"
                      />

                      <FormInputField
                        label="Password Repeated (Optional)"
                        name="passwordRepeated"
                        type="password"
                        placeholder="Text input"
                        value={passwordRepeated}
                        errorText={errors && errors.passwordRepeated}
                        helpText=""
                        onChange={(e) => setPasswordRepeated(e.target.value)}
                        isRequired={true}
                        maxWidth="380px"
                      />
                    </div>

                    <div class="columns">
                      <div class="column is-half">
                        <Link to={`/users`} class="button is-hidden-touch">
                          <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                          &nbsp;Back
                        </Link>
                        <Link
                          to={`/users`}
                          class="button is-fullwidth is-hidden-desktop"
                        >
                          <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                          &nbsp;Back
                        </Link>
                      </div>
                      <div class="column is-half has-text-right">
                        <button
                          onClick={onSubmitClick}
                          class="button is-primary is-hidden-touch"
                        >
                          <FontAwesomeIcon
                            className="fas"
                            icon={faCheckCircle}
                          />
                          &nbsp;Save
                        </button>
                        <button
                          onClick={onSubmitClick}
                          class="button is-primary is-fullwidth is-hidden-desktop"
                        >
                          <FontAwesomeIcon
                            className="fas"
                            icon={faCheckCircle}
                          />
                          &nbsp;Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </nav>
        </section>
      </div>
    </>
  );
}

export default OrgUserAdd;
